/**
 * parseResponse - helper function to parse text to a JSON
 * @param {String} text
 * @returns Object
 */
const parseResponse = (text) => (text.length ? JSON.parse(text) : {});

export default parseResponse;
